export const WORKSPACE_TEMPLATES = [
  {
    templateKey: "physical_range",
    label: "Physical range",
    eyebrow: "Facilities + operations",
    description: "Best for a place-based range managing members, facilities, daily operations, programs, and payments.",
    seededApps: "Membership, facilities, programs"
  },
  {
    templateKey: "chapter_organization",
    label: "Chapter organization",
    eyebrow: "Chapters + classes",
    description: "Best for clubs with city chapters, chapter leaders, memberships, included classes, and attendance reporting.",
    seededApps: "Membership, chapters, programs, staff portal"
  },
  {
    templateKey: "training_business",
    label: "Training business",
    eyebrow: "Instructors + programs",
    description: "Best for instructor-led programs, registrations, students, memberships or passes, and payments.",
    seededApps: "Membership, programs, staff portal"
  }
];

export function workspaceTemplateLabel(templateKey) {
  return WORKSPACE_TEMPLATES.find((template) => template.templateKey === templateKey)?.label || "Physical range";
}
